var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.44 163.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f0fb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Testi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.22.33V24h-37V37.19h26.6V59.66H62.25V95.58H32.72V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.29,81.64H122.72l-4.84,14.48H85.72L121.47.33h35.34l35.62,95.79h-32.3Zm-7.45-22.59L139,32.39l-8.83,26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.28.33V24h-25V95.58H200.76V24H176V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.21.33V24h-25V95.58H286.68V24H261.94V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.4,0V95.26H347.87V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.84,158.53q-7.12-5.13-7.72-15.06H50.49c.28,3.51,1.84,5.26,4.66,5.26a4.57,4.57,0,0,0,2.63-.73,2.57,2.57,0,0,0,1.08-2.29,4,4,0,0,0-2.33-3.5,46.93,46.93,0,0,0-7.25-3.06,76.62,76.62,0,0,1-9.71-4.06A18.9,18.9,0,0,1,33,129.31a15.75,15.75,0,0,1-2.67-9.75,16.71,16.71,0,0,1,3.06-10.14,19,19,0,0,1,8.38-6.35,31.42,31.42,0,0,1,12-2.16q11.22,0,17.82,5.18t7,14.59H57.82A5.11,5.11,0,0,0,56.53,117a4.17,4.17,0,0,0-2.94-1.12,2.6,2.6,0,0,0-2,.82,3.17,3.17,0,0,0-.78,2.28,3.91,3.91,0,0,0,2.29,3.41,50.82,50.82,0,0,0,7.29,3.24A82.93,82.93,0,0,1,70,129.74a20.42,20.42,0,0,1,6.52,5.53,14,14,0,0,1,2.76,8.89,18.11,18.11,0,0,1-10.79,17,28.89,28.89,0,0,1-12.52,2.5Q45,163.66,37.84,158.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.12,117.23v7.51h19v14.41h-19v8.63H126.7v15.28H86V102H126.7v15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.56,163.06H173.4l-20.29-30.73v30.73H134V102h19.16L173.4,133.2V102h19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.18,102v15.19H233v45.92H213.79V117.14h-16V102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.52,102v61.11H254.36V102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.88,163.06,301.4,141.14h-.09v21.92H282.15V102h28.48a28.19,28.19,0,0,1,12.69,2.63,18.37,18.37,0,0,1,7.9,7.17A20,20,0,0,1,333.85,122a18.18,18.18,0,0,1-3.41,10.88,18.7,18.7,0,0,1-9.8,6.82l13.3,23.39Zm-11.57-34.7h7.6a6,6,0,0,0,4.14-1.25,6,6,0,0,0,0-7.72,5.67,5.67,0,0,0-4.1-1.39h-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.14,117.23v7.51h19v14.41h-19v8.63h21.58v15.28H340V102h40.74v15.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc300",
    width: 12.71,
    height: 163.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc300",
    x: 400.73,
    width: 12.71,
    height: 163.06
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/claim.228b5db4b3734ad69e17000e87281124.svg";
export { ForwardRef as ReactComponent };